/**
 * The type of invite
 */
export enum InviteType {
  /**
   * The way in which two persons are connected, the state of being connected.
   */
  Relationship = 'relationship',

  /**
   * Request to obtain a caregiver administrator role.
   */
  RelationshipAdministrator = 'relationship-administrator',

  /**
   * The state or process of affiliating or being affiliated.
   */
  Affiliation = 'affiliation',
}
